import axios from 'axios';
import { getAuthToken } from '../utils/sessionAuth.js';

const API_URL = `${process.env.REACT_APP_BACKEND_SERVER}/api/directory-users`;

const authHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const listDirectoryUsers = async () => {
  const { data } = await axios.get(API_URL, { headers: authHeaders() });
  return data;
};

const getRoles = async () => {
  const { data } = await axios.get(`${API_URL}/roles`, { headers: authHeaders() });
  return data;
};

const createDirectoryUser = async (payload) => {
  const { data } = await axios.post(API_URL, payload, {
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
  });
  return data;
};

const updateDirectoryUser = async (id, payload) => {
  const { data } = await axios.patch(`${API_URL}/${id}`, payload, {
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
  });
  return data;
};

const deleteDirectoryUser = async (id) => {
  const { data } = await axios.delete(`${API_URL}/${id}`, { headers: authHeaders() });
  return data;
};

const directoryUserService = {
  listDirectoryUsers,
  getRoles,
  createDirectoryUser,
  updateDirectoryUser,
  deleteDirectoryUser,
};
export default directoryUserService;
